import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { IUser } from '../types/IUser';
import { Request } from './Request';

export interface IGetUsersForDataAlertParams extends IGetItemsParams {
  dataAlertId: string;
}

export interface IGetUsersForDataAlertResult extends IGetItemsResult {
  users: IUser[];
}

export class GetUsersForDataAlertRequest extends Request<IGetItemsParams, IGetUsersForDataAlertResult> {
  constructor(params: IGetUsersForDataAlertParams) {
    super('getUsersForDataAlert', params);
  }
}
